export const MAP_VALUES_TH = Object.freeze({
  // Zoom level to show Bangkok as well as Phuket
  latitude_w: 11.2312766,
  longitude_w: 99.554527,
  latitude_wm: 11.2312766,
  longitude_wm: 99.654527,
  zoom: 7,
  zoom_mbl: 6,
})

export const MAP_VALUES_SG = Object.freeze({
  latitude_w: 1.301422,
  longitude_w: 103.837725,
  latitude_wm: 1.302422,
  longitude_wm: 103.836225,
  zoom: 12,
  zoom_mbl: 12,
})
